import { Moment } from 'moment';

export const enum Channel {
  MAPP = 'MAPP',
  WEB = 'WEB'
}

export interface IBankingUserProfile {
  id?: number;
  cnic?: number;
  mobileNumber?: number;
  accNumber?: string;
  channel?: Channel;
  picture?: string;
  dateLogin?: Moment;
  dateCreated?: Moment;
  dateUpdated?: Moment;
  bankingUserProfileId?: number;
}

export const defaultValue: Readonly<IBankingUserProfile> = {};
